import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import LectureApi from "../../../api/lecture.api";
import DelBtn from "../../../component/atoms/button/delBtn";
import DetailBtn from "../../../component/atoms/button/detailBtn";
import TableDelBtn from "../../../component/atoms/button/tableDelBtn";
import Checkbox from "../../../component/atoms/input/checkbox";
import SearchBar from "../../../component/atoms/input/searchBar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Table from "../../../component/atoms/layout/table/table";
import TableSearchBtn from "../../../component/atoms/layout/table/tableSearchBtn";
import TableTop from "../../../component/atoms/layout/table/tableTop";
import Td from "../../../component/atoms/layout/table/td";
import Th from "../../../component/atoms/layout/table/th";
import Tr from "../../../component/atoms/layout/table/tr";
import TableText from "../../../component/atoms/text/table/tableText";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import Pagination from "../../../component/molecules/pagination";
import TableCount from "../../../component/molecules/tableCount";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import Modal from "../../../component/templates/Modal";
import { route } from "../../../router/route";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import moment from "moment";

const OnBoarding = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    getOnBoardingList();
  }, [location]);

  const [onBoardingList, setOnBoardingList] = useState([]);
  const [keyword, setKeyword] = useState("");

  const getOnBoardingList = async () => {
    try {
      const data = {
        keyword: searchParams.get("keyword"),
        page: searchParams.get("page"),
        size: pagination.size,
      };
      let responseData = (await LectureApi.getOnboarding(data)).data.data;

      setOnBoardingList(
        responseData.content.map((item) => {
          return {
            ...item,
            checked: false,
          };
        })
      );
      setPagination({
        ...pagination,
        totalCount: responseData.totalCount ? responseData.totalCount : 0,
        totalPages: Math.ceil(responseData.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 목록 가져오기
  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
  });

  const isAllCheck = useMemo(() => {
    const checkedList = onBoardingList.filter((item) => item.checked);
    return (
      checkedList.length !== 0 && checkedList.length === onBoardingList.length
    );
  }, [onBoardingList]);

  // ----- 삭제
  const [delIdList, setDelIdList] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      const data = {
        ids: delIdList,
      };
      await LectureApi.delOnboarding(data);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      setDelIdList([]);
      getOnBoardingList();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <div style={{ marginTop: "40px" }}>
            <TableTitle>온보딩 관리</TableTitle>
            <TableTop>
              <TableCount text={"항목"} count={pagination.totalCount} />
              <TableSearchBtn>
                <SearchBar
                  value={keyword}
                  onChange={(e) => {
                    setKeyword(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      navigate(
                        `${route.lecture_onboarding}?page=1&keyword=${encodeURIComponent(keyword)}`,
                        {
                          replace: true,
                        }
                      );
                    }
                  }}
                  onClick={() => {
                    navigate(
                      `${route.lecture_onboarding}?page=1&keyword=${encodeURIComponent(keyword)}`,
                      {
                        replace: true,
                      }
                    );
                  }}
                />

                <DelBtn
                  text={"선택항목 삭제"}
                  onClick={() => {
                    const delList = onBoardingList.filter(
                      (item) => item.checked
                    );
                    if (delList.length <= 0) {
                      return;
                    }
                    setDelIdList(delList.map((item) => item.id));
                    setDeleteModalOpen(true);
                  }}
                />
              </TableSearchBtn>
            </TableTop>
            <Table>
              <colgroup>
                {/* 체크박스 */}
                <col width="70px" />
                {/* 아이디 */}
                <col width="137px" />
                {/* 이름 */}
                <col width="509px" />
                {/* 참여일 */}
                <col width="139px" />
                {/* 삭제하기 */}
                <col width="91px" />
                {/* 상세보기 */}
                <col width="73px" />
              </colgroup>
              <thead>
                <Tr style={{ height: "41px", background: "#f2f4f5" }}>
                  <Th style={{ paddingLeft: "20px" }}>
                    <Checkbox
                      checked={isAllCheck}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setOnBoardingList(
                            onBoardingList.map((item) => {
                              return {
                                ...item,
                                checked: true,
                              };
                            })
                          );
                        } else {
                          setOnBoardingList(
                            onBoardingList.map((item) => {
                              return {
                                ...item,
                                checked: false,
                              };
                            })
                          );
                        }
                      }}
                    />
                  </Th>
                  <Th>
                    <TableText>아이디</TableText>
                  </Th>
                  <Th>
                    <TableText>이름</TableText>
                  </Th>
                  <Th>
                    <TableText>참여일</TableText>
                  </Th>
                  <Th>
                    <TableText>삭제하기</TableText>
                  </Th>
                  <Th>
                    <TableText>상세보기</TableText>
                  </Th>
                </Tr>
              </thead>
              <tbody>
                {onBoardingList.map((item, index) => {
                  return (
                    <Tr
                      key={index}
                      style={{ height: "59px", background: "#fff" }}
                    >
                      <Td style={{ paddingLeft: "20px" }}>
                        <Checkbox
                          checked={item.checked}
                          onChange={() => {
                            item.checked = !item.checked;
                            setOnBoardingList([...onBoardingList]);
                          }}
                        />
                      </Td>
                      <Td>
                        <TableText>{item.member?.account}</TableText>
                      </Td>
                      <Td>
                        <TableText>{item.member?.name}</TableText>
                      </Td>
                      <Td>
                        <TableText>
                          {moment(item.createdAt).format("YYYY/MM/DD")}
                        </TableText>
                      </Td>
                      <Td>
                        <TableDelBtn
                          onClick={() => {
                            const delList = [item];
                            setDelIdList(delList.map((item) => item.id));
                            setDeleteModalOpen(true);
                          }}
                        />
                      </Td>
                      <Td>
                        <DetailBtn
                          onClick={() => {
                            navigate(
                              route.lecture_onboarding_detail + `/${item.id}`
                            );
                          }}
                        />
                      </Td>
                    </Tr>
                  );
                })}
              </tbody>
            </Table>
            <Pagination
              route={route.lecture_onboarding}
              queryString={`keyword=${encodeURIComponent(searchParams.get("keyword") || "")}`}
              currentPage={page}
              totalPages={pagination.totalPages}
              rangeSize={pagination.rangeSize}
            />
          </div>
        </DetailPageLayout>
      </MainLayout>

      {deleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}
    </>
  );
};

export default OnBoarding;
